import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query'

import * as PlaceKeys from '../reactQueryKeys/place'

import { getPlaceByLatLong } from 'api/search'
import { GeoPlace } from 'tripPlanner/types/common'
import * as SearchKeys from '../reactQueryKeys/search'

type Places = {
  country: App.Place
  city: App.Place
}

export const useSearchPlace = (
  { lat, lng, type }: Partial<GeoPlace['point']> & { type: App.PlaceType },
  options?: UseQueryOptions<
    App.Place | undefined,
    unknown,
    App.Place | undefined
  >,
): UseQueryResult<App.Place | undefined, unknown> => {
  return useQuery({
    queryKey:
      lat !== undefined && lng !== undefined ?
          PlaceKeys.searchPlaceDetail(lat, lng, type) :
        undefined,
    queryFn:
      lat !== undefined && lng !== undefined ?
          () => getPlaceByLatLong(lat, lng, type) :
          () => Promise.resolve(undefined),
    ...options,
  })
}

export function useCityCountry({
  lat,
  lng,
}: Partial<GeoPlace['point']>): Partial<Places> {
  const { data: country } = useSearchPlace({ lat, lng, type: 'country' })
  const { data: city } = useSearchPlace({ lat, lng, type: 'city' })

  return {
    country,
    city,
  }
}

export const useLEPlaceByCoordinates = (
  lat: number,
  lng: number,
): UseQueryResult<App.Place, unknown> => {
  return useQuery(
    SearchKeys.placeByCoordinates(lat, lng),
    () => getPlaceByLatLong(lat, lng),
    {
      staleTime: Infinity,
    },
  )
}
